import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';
import { Observable } from 'rxjs';
import { AnyValue } from '@shared/types/any-value.type';

export const ACCEPT_INVITATION_PATH = 'accept_invitation_path';
export const ACCEPT_INVITATION_REQUEST_KEY_STORAGE = 'accept_invitation';

@Injectable({
  providedIn: 'root',
})
export class AcceptInvitationService {
  DOMAIN_BASE_ROUTE_API = `api/v1.0/domains/invitations`;

  invitationRequest() {
    sessionStorage.setItem(ACCEPT_INVITATION_REQUEST_KEY_STORAGE, 'true');
  }

  get getJoinDomainFromInvitationPath(): string | null {
    return sessionStorage.getItem(ACCEPT_INVITATION_PATH);
  }

  get acceptInvitationRequest(): boolean {
    return !!sessionStorage.getItem(ACCEPT_INVITATION_REQUEST_KEY_STORAGE);
  }

  clear() {
    sessionStorage.removeItem(ACCEPT_INVITATION_PATH);
    sessionStorage.removeItem(ACCEPT_INVITATION_REQUEST_KEY_STORAGE);
  }

  public constructor(
    private readonly httpClient: HttpClient,
    private readonly configService: ConfigurationService,
  ) {}

  public acceptInvitation(code: string): Observable<AnyValue> {
    return this.httpClient.get<AnyValue>(
      `${this.configService.urlApiSiVision}/${this.DOMAIN_BASE_ROUTE_API}/${code}/accept`,
    );
  }
}
